export default [
  { value: 'Townhouse', label: 'Townhouse' },
  { value: 'Contemporary', label: 'Contemporary' },
  { value: 'Low rise', label: 'Low rise' },
  { value: 'Mid rise', label: 'Mid rise' },
  { value: 'High rise', label: 'High rise' },
];
